import React from 'react';
import { DialogUI } from '../Interface';
import { DailyReportPage } from './DailyReportPage';
import { Box } from '@mui/material';

const DailyReportDialog = ({ open, handleClose, task, setTaskChanged }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Napi lejelentés"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <Box mt="1rem">
        <DailyReportPage data={task} handleClose={handleClose} setTaskChanged={setTaskChanged} />
      </Box>
    </DialogUI>
  );
};

export default DailyReportDialog;
